"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_2eu38btboh = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/useRepository.js";
  var hash = "bfa0fae3bd26eafd028e569949dd914c7e68f6a2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/useRepository.js",
    statementMap: {
      "0": {
        start: {
          line: 34,
          column: 30
        },
        end: {
          line: 34,
          column: 48
        }
      },
      "1": {
        start: {
          line: 35,
          column: 21
        },
        end: {
          line: 35,
          column: 61
        }
      },
      "2": {
        start: {
          line: 36,
          column: 24
        },
        end: {
          line: 36,
          column: 40
        }
      },
      "3": {
        start: {
          line: 37,
          column: 15
        },
        end: {
          line: 37,
          column: 52
        }
      },
      "4": {
        start: {
          line: 42,
          column: 17
        },
        end: {
          line: 53,
          column: 28
        }
      },
      "5": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "6": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 50,
          column: 7
        }
      },
      "7": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 36
        }
      },
      "8": {
        start: {
          line: 48,
          column: 25
        },
        end: {
          line: 48,
          column: 43
        }
      },
      "9": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 39
        }
      },
      "10": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 26
        }
      },
      "11": {
        start: {
          line: 55,
          column: 15
        },
        end: {
          line: 60,
          column: 22
        }
      },
      "12": {
        start: {
          line: 56,
          column: 24
        },
        end: {
          line: 58,
          column: 6
        }
      },
      "13": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 24
        }
      },
      "14": {
        start: {
          line: 62,
          column: 23
        },
        end: {
          line: 64,
          column: 8
        }
      },
      "15": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 23
        }
      },
      "16": {
        start: {
          line: 66,
          column: 17
        },
        end: {
          line: 69,
          column: 22
        }
      },
      "17": {
        start: {
          line: 67,
          column: 24
        },
        end: {
          line: 67,
          column: 68
        }
      },
      "18": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 24
        }
      },
      "19": {
        start: {
          line: 71,
          column: 28
        },
        end: {
          line: 76,
          column: 40
        }
      },
      "20": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      "21": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 47
        }
      },
      "22": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 37
        }
      },
      "23": {
        start: {
          line: 78,
          column: 15
        },
        end: {
          line: 83,
          column: 40
        }
      },
      "24": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 82,
          column: 5
        }
      },
      "25": {
        start: {
          line: 80,
          column: 20
        },
        end: {
          line: 80,
          column: 64
        }
      },
      "26": {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 20
        }
      },
      "27": {
        start: {
          line: 85,
          column: 15
        },
        end: {
          line: 94,
          column: 34
        }
      },
      "28": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 93,
          column: 5
        }
      },
      "29": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 91,
          column: 9
        }
      },
      "30": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 92,
          column: 26
        }
      },
      "31": {
        start: {
          line: 96,
          column: 19
        },
        end: {
          line: 98,
          column: 26
        }
      },
      "32": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 53
        }
      },
      "33": {
        start: {
          line: 100,
          column: 20
        },
        end: {
          line: 102,
          column: 26
        }
      },
      "34": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 54
        }
      },
      "35": {
        start: {
          line: 104,
          column: 22
        },
        end: {
          line: 109,
          column: 26
        }
      },
      "36": {
        start: {
          line: 105,
          column: 17
        },
        end: {
          line: 107,
          column: 6
        }
      },
      "37": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 16
        }
      },
      "38": {
        start: {
          line: 111,
          column: 16
        },
        end: {
          line: 113,
          column: 26
        }
      },
      "39": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 44
        }
      },
      "40": {
        start: {
          line: 115,
          column: 16
        },
        end: {
          line: 117,
          column: 14
        }
      },
      "41": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 116,
          column: 13
        }
      },
      "42": {
        start: {
          line: 119,
          column: 2
        },
        end: {
          line: 123,
          column: 25
        }
      },
      "43": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 122,
          column: 5
        }
      },
      "44": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 121,
          column: 26
        }
      },
      "45": {
        start: {
          line: 125,
          column: 2
        },
        end: {
          line: 129,
          column: 35
        }
      },
      "46": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 128,
          column: 5
        }
      },
      "47": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 127,
          column: 40
        }
      },
      "48": {
        start: {
          line: 131,
          column: 2
        },
        end: {
          line: 136,
          column: 37
        }
      },
      "49": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 135,
          column: 5
        }
      },
      "50": {
        start: {
          line: 133,
          column: 28
        },
        end: {
          line: 133,
          column: 50
        }
      },
      "51": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 134,
          column: 28
        }
      },
      "52": {
        start: {
          line: 138,
          column: 24
        },
        end: {
          line: 138,
          column: 99
        }
      },
      "53": {
        start: {
          line: 140,
          column: 19
        },
        end: {
          line: 140,
          column: 88
        }
      },
      "54": {
        start: {
          line: 141,
          column: 21
        },
        end: {
          line: 164,
          column: 3
        }
      },
      "55": {
        start: {
          line: 166,
          column: 18
        },
        end: {
          line: 166,
          column: 23
        }
      },
      "56": {
        start: {
          line: 168,
          column: 2
        },
        end: {
          line: 174,
          column: 3
        }
      },
      "57": {
        start: {
          line: 169,
          column: 4
        },
        end: {
          line: 169,
          column: 32
        }
      },
      "58": {
        start: {
          line: 170,
          column: 9
        },
        end: {
          line: 174,
          column: 3
        }
      },
      "59": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 171,
          column: 34
        }
      },
      "60": {
        start: {
          line: 172,
          column: 9
        },
        end: {
          line: 174,
          column: 3
        }
      },
      "61": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 173,
          column: 34
        }
      },
      "62": {
        start: {
          line: 176,
          column: 2
        },
        end: {
          line: 195,
          column: 4
        }
      },
      "63": {
        start: {
          line: 198,
          column: 0
        },
        end: {
          line: 238,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "useRepository",
        decl: {
          start: {
            line: 22,
            column: 9
          },
          end: {
            line: 22,
            column: 22
          }
        },
        loc: {
          start: {
            line: 33,
            column: 3
          },
          end: {
            line: 196,
            column: 1
          }
        },
        line: 33
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 42,
            column: 29
          },
          end: {
            line: 42,
            column: 30
          }
        },
        loc: {
          start: {
            line: 42,
            column: 39
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 42
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 55,
            column: 27
          },
          end: {
            line: 55,
            column: 28
          }
        },
        loc: {
          start: {
            line: 55,
            column: 54
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 55
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 62,
            column: 35
          },
          end: {
            line: 62,
            column: 36
          }
        },
        loc: {
          start: {
            line: 62,
            column: 48
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 62
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 66,
            column: 29
          },
          end: {
            line: 66,
            column: 30
          }
        },
        loc: {
          start: {
            line: 66,
            column: 49
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 66
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 71,
            column: 40
          },
          end: {
            line: 71,
            column: 41
          }
        },
        loc: {
          start: {
            line: 71,
            column: 46
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 71
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 78,
            column: 27
          },
          end: {
            line: 78,
            column: 28
          }
        },
        loc: {
          start: {
            line: 78,
            column: 39
          },
          end: {
            line: 83,
            column: 3
          }
        },
        line: 78
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 85,
            column: 27
          },
          end: {
            line: 85,
            column: 28
          }
        },
        loc: {
          start: {
            line: 85,
            column: 47
          },
          end: {
            line: 94,
            column: 3
          }
        },
        line: 85
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 96,
            column: 31
          },
          end: {
            line: 96,
            column: 32
          }
        },
        loc: {
          start: {
            line: 96,
            column: 43
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 96
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 100,
            column: 32
          },
          end: {
            line: 100,
            column: 33
          }
        },
        loc: {
          start: {
            line: 100,
            column: 43
          },
          end: {
            line: 102,
            column: 3
          }
        },
        line: 100
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 104,
            column: 34
          },
          end: {
            line: 104,
            column: 35
          }
        },
        loc: {
          start: {
            line: 104,
            column: 54
          },
          end: {
            line: 109,
            column: 3
          }
        },
        line: 104
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 111,
            column: 28
          },
          end: {
            line: 111,
            column: 29
          }
        },
        loc: {
          start: {
            line: 111,
            column: 34
          },
          end: {
            line: 113,
            column: 3
          }
        },
        line: 111
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 115,
            column: 28
          },
          end: {
            line: 115,
            column: 29
          }
        },
        loc: {
          start: {
            line: 115,
            column: 34
          },
          end: {
            line: 117,
            column: 3
          }
        },
        line: 115
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 119,
            column: 12
          },
          end: {
            line: 119,
            column: 13
          }
        },
        loc: {
          start: {
            line: 119,
            column: 18
          },
          end: {
            line: 123,
            column: 3
          }
        },
        line: 119
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 125,
            column: 12
          },
          end: {
            line: 125,
            column: 13
          }
        },
        loc: {
          start: {
            line: 125,
            column: 18
          },
          end: {
            line: 129,
            column: 3
          }
        },
        line: 125
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 131,
            column: 13
          }
        },
        loc: {
          start: {
            line: 131,
            column: 18
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 131
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 35,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 35,
            column: 33
          }
        }, {
          start: {
            line: 35,
            column: 37
          },
          end: {
            line: 35,
            column: 61
          }
        }],
        line: 35
      },
      "1": {
        loc: {
          start: {
            line: 36,
            column: 24
          },
          end: {
            line: 36,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 24
          },
          end: {
            line: 36,
            column: 34
          }
        }, {
          start: {
            line: 36,
            column: 38
          },
          end: {
            line: 36,
            column: 40
          }
        }],
        line: 36
      },
      "2": {
        loc: {
          start: {
            line: 37,
            column: 15
          },
          end: {
            line: 37,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 15
          },
          end: {
            line: 37,
            column: 29
          }
        }, {
          start: {
            line: 37,
            column: 33
          },
          end: {
            line: 37,
            column: 52
          }
        }],
        line: 37
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 50,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 50,
            column: 7
          }
        }, {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 50,
            column: 7
          }
        }],
        line: 46
      },
      "5": {
        loc: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }, {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }],
        line: 72
      },
      "6": {
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 12
          }
        }, {
          start: {
            line: 72,
            column: 16
          },
          end: {
            line: 72,
            column: 59
          }
        }],
        line: 72
      },
      "7": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }, {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }],
        line: 79
      },
      "8": {
        loc: {
          start: {
            line: 79,
            column: 9
          },
          end: {
            line: 79,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 9
          },
          end: {
            line: 79,
            column: 13
          }
        }, {
          start: {
            line: 79,
            column: 17
          },
          end: {
            line: 79,
            column: 30
          }
        }],
        line: 79
      },
      "9": {
        loc: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        }, {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 93,
            column: 5
          }
        }],
        line: 88
      },
      "10": {
        loc: {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 122,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 122,
            column: 5
          }
        }, {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 122,
            column: 5
          }
        }],
        line: 120
      },
      "11": {
        loc: {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }, {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }],
        line: 126
      },
      "12": {
        loc: {
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 126,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 8
          },
          end: {
            line: 126,
            column: 18
          }
        }, {
          start: {
            line: 126,
            column: 22
          },
          end: {
            line: 126,
            column: 50
          }
        }],
        line: 126
      },
      "13": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }, {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }],
        line: 132
      },
      "14": {
        loc: {
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 132,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 132,
            column: 19
          }
        }, {
          start: {
            line: 132,
            column: 23
          },
          end: {
            line: 132,
            column: 33
          }
        }],
        line: 132
      },
      "15": {
        loc: {
          start: {
            line: 138,
            column: 24
          },
          end: {
            line: 138,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 138,
            column: 24
          },
          end: {
            line: 138,
            column: 34
          }
        }, {
          start: {
            line: 138,
            column: 38
          },
          end: {
            line: 138,
            column: 53
          }
        }, {
          start: {
            line: 138,
            column: 57
          },
          end: {
            line: 138,
            column: 73
          }
        }, {
          start: {
            line: 138,
            column: 77
          },
          end: {
            line: 138,
            column: 99
          }
        }],
        line: 138
      },
      "16": {
        loc: {
          start: {
            line: 140,
            column: 19
          },
          end: {
            line: 140,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 19
          },
          end: {
            line: 140,
            column: 33
          }
        }, {
          start: {
            line: 140,
            column: 37
          },
          end: {
            line: 140,
            column: 56
          }
        }, {
          start: {
            line: 140,
            column: 60
          },
          end: {
            line: 140,
            column: 88
          }
        }],
        line: 140
      },
      "17": {
        loc: {
          start: {
            line: 142,
            column: 12
          },
          end: {
            line: 149,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 12
          },
          end: {
            line: 142,
            column: 18
          }
        }, {
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 148,
            column: 8
          }
        }],
        line: 142
      },
      "18": {
        loc: {
          start: {
            line: 144,
            column: 22
          },
          end: {
            line: 144,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 144,
            column: 22
          },
          end: {
            line: 144,
            column: 34
          }
        }, {
          start: {
            line: 144,
            column: 38
          },
          end: {
            line: 144,
            column: 46
          }
        }],
        line: 144
      },
      "19": {
        loc: {
          start: {
            line: 150,
            column: 12
          },
          end: {
            line: 157,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 150,
            column: 13
          },
          end: {
            line: 150,
            column: 17
          }
        }, {
          start: {
            line: 150,
            column: 21
          },
          end: {
            line: 150,
            column: 33
          }
        }, {
          start: {
            line: 151,
            column: 6
          },
          end: {
            line: 156,
            column: 8
          }
        }],
        line: 150
      },
      "20": {
        loc: {
          start: {
            line: 158,
            column: 10
          },
          end: {
            line: 160,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 10
          },
          end: {
            line: 158,
            column: 23
          }
        }, {
          start: {
            line: 159,
            column: 6
          },
          end: {
            line: 159,
            column: 88
          }
        }],
        line: 158
      },
      "21": {
        loc: {
          start: {
            line: 161,
            column: 10
          },
          end: {
            line: 163,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 161,
            column: 10
          },
          end: {
            line: 161,
            column: 23
          }
        }, {
          start: {
            line: 162,
            column: 6
          },
          end: {
            line: 162,
            column: 24
          }
        }],
        line: 161
      },
      "22": {
        loc: {
          start: {
            line: 168,
            column: 2
          },
          end: {
            line: 174,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 168,
            column: 2
          },
          end: {
            line: 174,
            column: 3
          }
        }, {
          start: {
            line: 168,
            column: 2
          },
          end: {
            line: 174,
            column: 3
          }
        }],
        line: 168
      },
      "23": {
        loc: {
          start: {
            line: 170,
            column: 9
          },
          end: {
            line: 174,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 9
          },
          end: {
            line: 174,
            column: 3
          }
        }, {
          start: {
            line: 170,
            column: 9
          },
          end: {
            line: 174,
            column: 3
          }
        }],
        line: 170
      },
      "24": {
        loc: {
          start: {
            line: 170,
            column: 13
          },
          end: {
            line: 170,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 170,
            column: 13
          },
          end: {
            line: 170,
            column: 17
          }
        }, {
          start: {
            line: 170,
            column: 21
          },
          end: {
            line: 170,
            column: 33
          }
        }],
        line: 170
      },
      "25": {
        loc: {
          start: {
            line: 172,
            column: 9
          },
          end: {
            line: 174,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 9
          },
          end: {
            line: 174,
            column: 3
          }
        }, {
          start: {
            line: 172,
            column: 9
          },
          end: {
            line: 174,
            column: 3
          }
        }],
        line: 172
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0, 0],
      "16": [0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "bfa0fae3bd26eafd028e569949dd914c7e68f6a2"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepFreeze = _interopRequireDefault(require("deep-freeze"));

var _ = require("../..");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function useRepository(_ref) {
  var repositories = _ref.repositories,
      __full_name = _ref.full_name,
      urls = _ref.urls,
      defaultOwner = _ref.defaultOwner,
      defaultQuery = _ref.defaultQuery,
      config = _ref.config,
      authentication = _ref.authentication,
      __repository = _ref.repository,
      onRepository = _ref.onRepository,
      __branch = _ref.branch;
  cov_2eu38btboh.f[0]++;

  var _ref2 = (cov_2eu38btboh.s[0]++, (0, _react.useState)(__branch)),
      _ref3 = _slicedToArray(_ref2, 2),
      branch = _ref3[0],
      setBranch = _ref3[1];

  var repository = (cov_2eu38btboh.s[1]++, (cov_2eu38btboh.b[0][0]++, __repository) && (cov_2eu38btboh.b[0][1]++, (0, _deepFreeze.default)(__repository)));

  var _ref4 = (cov_2eu38btboh.s[2]++, (cov_2eu38btboh.b[1][0]++, repository) || (cov_2eu38btboh.b[1][1]++, {})),
      full_name = _ref4.full_name;

  var user = (cov_2eu38btboh.s[3]++, (cov_2eu38btboh.b[2][0]++, authentication) && (cov_2eu38btboh.b[2][1]++, authentication.user)); // Due to objects not memoizing in useCallback, deconstruction is necessary
  // const { owner: { username: owner }, name: repo } = repository;

  var update = (cov_2eu38btboh.s[4]++, (0, _react.useCallback)(function (repo) {
    cov_2eu38btboh.f[1]++;
    cov_2eu38btboh.s[5]++;

    if (onRepository) {
      cov_2eu38btboh.b[3][0]++;

      var _repo;

      cov_2eu38btboh.s[6]++;

      if (repo) {
        cov_2eu38btboh.b[4][0]++;
        cov_2eu38btboh.s[7]++;
        _repo = _objectSpread({}, repo, {
          branch: branch
        });
        var tree_url = (cov_2eu38btboh.s[8]++, (0, _.repoTreeUrl)(_repo));
        cov_2eu38btboh.s[9]++;
        _repo = _objectSpread({}, _repo, {
          tree_url: tree_url
        });
      } else {
        cov_2eu38btboh.b[4][1]++;
      }

      ;
      cov_2eu38btboh.s[10]++;
      onRepository(_repo);
    } else {
      cov_2eu38btboh.b[3][1]++;
    }

    ;
  }, [branch, onRepository]));
  var read = (cov_2eu38btboh.s[11]++, (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5) {
      var owner, name, _repository;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              owner = _ref5.owner, name = _ref5.name;
              cov_2eu38btboh.f[2]++;
              cov_2eu38btboh.s[12]++;
              _context.next = 5;
              return (0, _helpers.readRepository)({
                owner: owner,
                repo: name,
                config: config
              });

            case 5:
              _repository = _context.sent;
              cov_2eu38btboh.s[13]++;
              update(_repository);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref6.apply(this, arguments);
    };
  }(), [config, update]));
  var updateBranch = (cov_2eu38btboh.s[14]++, (0, _react.useCallback)(function (_branch) {
    cov_2eu38btboh.f[3]++;
    cov_2eu38btboh.s[15]++;
    setBranch(_branch);
  }, []));
  var create = (cov_2eu38btboh.s[16]++, (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(settings) {
      var _repository;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              cov_2eu38btboh.f[4]++;
              cov_2eu38btboh.s[17]++;
              _context2.next = 4;
              return (0, _helpers.createRepository)({
                settings: settings,
                config: config
              });

            case 4:
              _repository = _context2.sent;
              cov_2eu38btboh.s[18]++;
              update(_repository);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref7.apply(this, arguments);
    };
  }(), [config, update]));
  var dangerouslyDelete = (cov_2eu38btboh.s[19]++, (0, _react.useCallback)(function () {
    cov_2eu38btboh.f[5]++;
    cov_2eu38btboh.s[20]++;

    if ((cov_2eu38btboh.b[6][0]++, user) && (cov_2eu38btboh.b[6][1]++, user.username === repository.owner.username)) {
      cov_2eu38btboh.b[5][0]++;
      cov_2eu38btboh.s[21]++;
      (0, _helpers.deleteRepository)({
        repository: repository,
        config: config
      });
      cov_2eu38btboh.s[22]++;
      window.setTimeout(update, 500);
    } else {
      cov_2eu38btboh.b[5][1]++;
    }

    ;
  }, [user, repository, config, update]));
  var fork = (cov_2eu38btboh.s[23]++, (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _repo;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            cov_2eu38btboh.f[6]++;
            cov_2eu38btboh.s[24]++;

            if (!(((cov_2eu38btboh.b[8][0]++, user) && (cov_2eu38btboh.b[8][1]++, user.username)) !== repository.owner.username)) {
              _context3.next = 12;
              break;
            }

            cov_2eu38btboh.b[7][0]++;
            cov_2eu38btboh.s[25]++;
            _context3.next = 7;
            return (0, _helpers.forkRepository)({
              repository: repository,
              config: config
            });

          case 7:
            _repo = _context3.sent;
            cov_2eu38btboh.s[26]++;
            update(_repo);
            _context3.next = 13;
            break;

          case 12:
            cov_2eu38btboh.b[7][1]++;

          case 13:
            ;

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [config, repository, update, user]));
  var save = (cov_2eu38btboh.s[27]++, (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(settings) {
      var _repository;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              cov_2eu38btboh.f[7]++;
              cov_2eu38btboh.s[28]++;

              if (!repository.permissions.admin) {
                _context4.next = 12;
                break;
              }

              cov_2eu38btboh.b[9][0]++;
              cov_2eu38btboh.s[29]++;
              _context4.next = 7;
              return (0, _helpers.saveRepository)({
                repository: repository,
                settings: settings,
                config: config
              });

            case 7:
              _repository = _context4.sent;
              cov_2eu38btboh.s[30]++;
              update(_repository);
              _context4.next = 13;
              break;

            case 12:
              cov_2eu38btboh.b[9][1]++;

            case 13:
              ;

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x3) {
      return _ref9.apply(this, arguments);
    };
  }(), [config, repository, update]));
  var storeZip = (cov_2eu38btboh.s[31]++, (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            cov_2eu38btboh.f[8]++;
            cov_2eu38btboh.s[32]++;
            _context5.next = 4;
            return (0, _helpers.storeRepositoryZip)({
              repository: repository,
              config: config
            });

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })), [repository, config]));
  var removeZip = (cov_2eu38btboh.s[33]++, (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            cov_2eu38btboh.f[9]++;
            cov_2eu38btboh.s[34]++;
            _context6.next = 4;
            return (0, _helpers.removeRepositoryZip)({
              repository: repository,
              config: config
            });

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  })), [repository, config]));
  var fileFromZip = (cov_2eu38btboh.s[35]++, (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(filepath) {
      var file;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              cov_2eu38btboh.f[10]++;
              cov_2eu38btboh.s[36]++;
              _context7.next = 4;
              return (0, _helpers.getFileFromRepositoryZip)({
                repository: repository,
                filepath: filepath,
                config: config
              });

            case 4:
              file = _context7.sent;
              cov_2eu38btboh.s[37]++;
              return _context7.abrupt("return", file);

            case 7:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x4) {
      return _ref12.apply(this, arguments);
    };
  }(), [repository, config]));
  var forks = (cov_2eu38btboh.s[38]++, (0, _react.useCallback)(function () {
    cov_2eu38btboh.f[11]++;
    cov_2eu38btboh.s[39]++;
    (0, _helpers.repositoryForks)({
      repository: repository,
      config: config
    });
  }, [repository, config]));
  var close = (cov_2eu38btboh.s[40]++, (0, _react.useCallback)(function () {
    cov_2eu38btboh.f[12]++;
    cov_2eu38btboh.s[41]++;
    update();
  }, [update]));
  cov_2eu38btboh.s[42]++;
  (0, _react.useEffect)(function () {
    cov_2eu38btboh.f[13]++;
    cov_2eu38btboh.s[43]++;

    if (__branch !== branch) {
      cov_2eu38btboh.b[10][0]++;
      cov_2eu38btboh.s[44]++;
      setBranch(__branch);
    } else {
      cov_2eu38btboh.b[10][1]++;
    }
  }, [__branch, branch]);
  cov_2eu38btboh.s[45]++;
  (0, _react.useEffect)(function () {
    cov_2eu38btboh.f[14]++;
    cov_2eu38btboh.s[46]++;

    if ((cov_2eu38btboh.b[12][0]++, repository) && (cov_2eu38btboh.b[12][1]++, branch !== repository.branch)) {
      cov_2eu38btboh.b[11][0]++;
      cov_2eu38btboh.s[47]++;
      update(_objectSpread({}, repository, {
        branch: branch
      }));
    } else {
      cov_2eu38btboh.b[11][1]++;
    }
  }, [branch, repository, update]);
  cov_2eu38btboh.s[48]++;
  (0, _react.useEffect)(function () {
    cov_2eu38btboh.f[15]++;
    cov_2eu38btboh.s[49]++;

    if ((cov_2eu38btboh.b[14][0]++, __full_name) && (cov_2eu38btboh.b[14][1]++, !full_name)) {
      cov_2eu38btboh.b[13][0]++;

      var _ref13 = (cov_2eu38btboh.s[50]++, __full_name.split('/')),
          _ref14 = _slicedToArray(_ref13, 2),
          owner = _ref14[0],
          name = _ref14[1];

      cov_2eu38btboh.s[51]++;
      read({
        owner: owner,
        name: name
      });
    } else {
      cov_2eu38btboh.b[13][1]++;
    }

    ;
  }, [full_name, __full_name, read]);
  var hasRepository = (cov_2eu38btboh.s[52]++, (cov_2eu38btboh.b[15][0]++, repository) && (cov_2eu38btboh.b[15][1]++, repository.name) && (cov_2eu38btboh.b[15][2]++, repository.owner) && (cov_2eu38btboh.b[15][3]++, repository.permissions));
  var username = (cov_2eu38btboh.s[53]++, (cov_2eu38btboh.b[16][0]++, authentication) && (cov_2eu38btboh.b[16][1]++, authentication.user) && (cov_2eu38btboh.b[16][2]++, authentication.user.username));
  var components = (cov_2eu38btboh.s[54]++, {
    search: (cov_2eu38btboh.b[17][0]++, config) && (cov_2eu38btboh.b[17][1]++, /*#__PURE__*/_react.default.createElement(_.Search, {
      defaultOwner: (cov_2eu38btboh.b[18][0]++, defaultOwner) || (cov_2eu38btboh.b[18][1]++, username),
      defaultQuery: defaultQuery,
      onRepository: update,
      config: config
    })),
    browse: ((cov_2eu38btboh.b[19][0]++, urls) || (cov_2eu38btboh.b[19][1]++, repositories)) && (cov_2eu38btboh.b[19][2]++, /*#__PURE__*/_react.default.createElement(_.Repositories, {
      urls: urls,
      repositories: repositories,
      onRepository: update,
      config: config
    })),
    view: (cov_2eu38btboh.b[20][0]++, hasRepository) && (cov_2eu38btboh.b[20][1]++, /*#__PURE__*/_react.default.createElement(_.Repository, {
      repository: repository,
      config: config,
      onRepository: onRepository
    })),
    form: (cov_2eu38btboh.b[21][0]++, hasRepository) && (cov_2eu38btboh.b[21][1]++, /*#__PURE__*/_react.default.createElement(_.RepositoryForm, null))
  });
  var component = (cov_2eu38btboh.s[55]++, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  cov_2eu38btboh.s[56]++;

  if (hasRepository) {
    cov_2eu38btboh.b[22][0]++;
    cov_2eu38btboh.s[57]++;
    component = components.form;
  } else {
    cov_2eu38btboh.b[22][1]++;
    cov_2eu38btboh.s[58]++;

    if ((cov_2eu38btboh.b[24][0]++, urls) || (cov_2eu38btboh.b[24][1]++, repositories)) {
      cov_2eu38btboh.b[23][0]++;
      cov_2eu38btboh.s[59]++;
      component = components.browse;
    } else {
      cov_2eu38btboh.b[23][1]++;
      cov_2eu38btboh.s[60]++;

      if (config) {
        cov_2eu38btboh.b[25][0]++;
        cov_2eu38btboh.s[61]++;
        component = components.search;
      } else {
        cov_2eu38btboh.b[25][1]++;
      }
    }
  }

  ;
  cov_2eu38btboh.s[62]++;
  return {
    state: repository,
    actions: {
      close: close,
      create: create,
      update: update,
      dangerouslyDelete: dangerouslyDelete,
      fork: fork,
      save: save,
      forks: forks,
      updateBranch: updateBranch,
      read: read,
      storeZip: storeZip,
      removeZip: removeZip,
      fileFromZip: fileFromZip
    },
    component: component,
    components: components,
    config: config
  };
}

;
cov_2eu38btboh.s[63]++;
useRepository.propTypes = {
  /** Repository data to render, if url not provided. */
  repository: _propTypes.default.shape({
    id: _propTypes.default.number,
    owner: _propTypes.default.object.isRequired,
    name: _propTypes.default.string.isRequired,
    full_name: _propTypes.default.string.isRequired,
    description: _propTypes.default.string.isRequired,
    html_url: _propTypes.default.string.isRequired,
    website: _propTypes.default.string.isRequired,
    tree_url: _propTypes.default.string,
    avatar_url: _propTypes.default.string,
    branch: _propTypes.default.string
  }),

  /** Function to call when repository is selected. */
  onRepository: _propTypes.default.func.isRequired,

  /** Full name of the repo, `owner/name` */
  full_name: _propTypes.default.string,

  /** Pass a previously returned authentication object to bypass login. */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object.isRequired,
    token: _propTypes.default.object.isRequired,
    config: _propTypes.default.object.isRequired,
    remember: _propTypes.default.bool
  }),

  /** Urls array to get repository data, if repository data is not provided. */
  urls: _propTypes.default.array,

  /** Repositories data array to render, if urls not provided. */
  repositories: _propTypes.default.array,

  /** Prefill the owner search field. */
  defaultOwner: _propTypes.default.string,

  /** Prefill the query search field. */
  defaultQuery: _propTypes.default.string,

  /** The name of the branch to read/write files */
  branch: _propTypes.default.string,

  /** Configuration to pass through to the Search/Repositories component. */
  config: _propTypes.default.shape({
    /** Configuration required for Search or Repositories if paths are provided as URL. */
    server: _propTypes.default.string
  }).isRequired
};
var _default = useRepository;
exports.default = _default;